import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import { socialNetworkSegments } from "@/lib/data/social-network";
import { createFileRoute, Link } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/social-network/"
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "My Social Network - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "weakness.exercises.network",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const currentSegment = socialNetworkSegments[0];

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Link to="/children/exercises/social-network/exercise">
          <Button className="w-full">
            <FormattedMessage
              id="breathing.startExercise"
              defaultMessage="Start Exercise"
            />
          </Button>
        </Link>
      }
    >
      <div className="space-y-1">
        <p className="text-small">
          <FormattedMessage id="network.intro" />
        </p>
        <p className="text-small">
          <FormattedMessage id="network.introGoalTitle" /> <br />
          <FormattedMessage id="network.introGoal" />
        </p>
      </div>
      <>
        <MediaPlayer
          src={currentSegment.audio}
          segment={currentSegment.segment}
        />
      </>
    </ExerciseLayout>
  );
}
